module.exports = __webpack_public_path__ + "static/media/calque3.2139b175.png";